import React from 'react';
import { PatternFormat } from 'react-number-format';

export default function PhoneNumberInput(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <PatternFormat
            {...other}
            getInputRef={inputRef}
            format="(###) ###-####"
            mask="_"
            allowEmptyFormatting={false}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.formattedValue,
                    },
                });
            }}
        />
    );
}
